import { useState } from "react";
import { Link } from "react-router-dom";

const treatments = {
  acne: {
    title: "Trattamento Acne",
    description:
      "Protocollo personalizzato con microneedling e LED terapia per ridurre infiammazione e migliorare la qualità della pelle.",
    duration: "Durata media: 45 minuti",
  },

  macchie: {
    title: "Riduzione Macchie",
    description:
      "Peeling chimici e tecnologie avanzate per uniformare il colorito e ridurre le iperpigmentazioni.",
    duration: "Durata media: 40 minuti",
  },

  rughe: {
    title: "Trattamento Antiage",
    description:
      "Protocollo rigenerativo con needling e attivi specifici per stimolare collagene ed elasticità.",
    duration: "Durata media: 50 minuti",
  },

  pori: {
    title: "Riduzione Pori",
    description:
      "Trattamento purificante e rigenerante per affinare la grana della pelle e migliorare la texture.",
    duration: "Durata media: 40 minuti",
  },
};

export default function TreatmentConfigurator() {

  const [selected, setSelected] = useState<string | null>(null);

  return (

    <section className="py-28 bg-white">

      <div className="max-w-5xl mx-auto px-6 text-center">

        <h2 className="font-serif text-4xl md:text-5xl text-alkimya-navy mb-6">
          Trova il Trattamento Giusto
        </h2>

        <p className="text-gray-600 mb-12">
          Seleziona il tuo inestetismo principale e scopri il trattamento
          consigliato.
        </p>

        {/* BOTTONI */}

        <div className="flex flex-wrap justify-center gap-4 mb-12">

          <button
            onClick={() => setSelected("acne")}
            className="px-6 py-3 rounded-full border border-gray-300 hover:bg-alkimya-navy hover:text-white transition"
          >
            Acne
          </button>

          <button
            onClick={() => setSelected("macchie")}
            className="px-6 py-3 rounded-full border border-gray-300 hover:bg-alkimya-navy hover:text-white transition"
          >
            Macchie
          </button>

          <button
            onClick={() => setSelected("rughe")}
            className="px-6 py-3 rounded-full border border-gray-300 hover:bg-alkimya-navy hover:text-white transition"
          >
            Rughe
          </button>

          <button
            onClick={() => setSelected("pori")}
            className="px-6 py-3 rounded-full border border-gray-300 hover:bg-alkimya-navy hover:text-white transition"
          >
            Pori Dilatati
          </button>

        </div>

        {/* RISULTATO */}

        {selected && (

          <div className="bg-[#f8f5f1] p-10 rounded-2xl shadow-md max-w-xl mx-auto">

            <h3 className="text-2xl font-serif mb-4">
              {treatments[selected as keyof typeof treatments].title}
            </h3>

            <p className="text-gray-700 mb-4">
              {treatments[selected as keyof typeof treatments].description}
            </p>

            <p className="text-sm text-gray-500 mb-6">
              {treatments[selected as keyof typeof treatments].duration}
            </p>

            <Link
              to="/consulenza"
              className="inline-block px-6 py-3 rounded-full bg-alkimya-navy text-white hover:scale-105 transition"
            >
              Prenota una consulenza
            </Link>

          </div>

        )}

      </div>

    </section>

  );

}